import Ordinal from 'ordinal';

export const formatEnToOrdinal = (num, locale) => {
  if (locale === 'en-US') {
    return Ordinal(num);
  }
  return num;
};
